const CHAIN_ID_HEX = '0x38';
const rpcUrls = 'https://bsc-dataseed1.ninicoin.io/';
const blockExplorerUrls = 'https://bscscan.com/';

export default async () => {
  if (typeof window === 'undefined') return;

  const { ethereum } = window;
  if (!ethereum) return 'reject';
  const data = [
    {
      chainId: CHAIN_ID_HEX,
      chainName: 'Binance Smart Chain',
      nativeCurrency: {
        name: 'BNB',
        symbol: 'BNB',
        decimals: 18,
      },
      rpcUrls: [rpcUrls],
      blockExplorerUrls: [blockExplorerUrls],
    },
  ];

  try {
    await ethereum.request({ method: 'wallet_addEthereumChain', params: data });
  } catch (error) {
    return error;
  }
};
